import User from "assets/icons/User";
import { useState } from "react";
import ChevronFilled from "assets/icons/ChevronFilled";
import { Link } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import useUser from "context/hooks/user";
import { t } from "i18next";
import Loader from "components/Loader";
import { useUserLogout } from "api/user";
import { useModal } from "context/hooks/useModal";

export default function UserSection({ color }) {
  const { dir } = useAppSelector(getSettings);
  const { data: userDetail } = useUser();
  const [openDropdown, setOpenDropdown] = useState(false);
  const { mutate: logout, isPending: loggingUserOut } = useUserLogout();
  const { showModal, hideModal } = useModal();

  const RenderContent = ({ url }) => {
    return (
      <div className="max-h-[90vh] md:max-h-[70vh] overflow-y-auto">
        <button
          className="rounded-full border border-black w-6 h-6"
          onClick={hideModal}
        >
          X
        </button>
        <div className="w-full" id="iframe-loader">
          <Loader open type="block" />
        </div>

        <iframe
          src={url}
          className="w-full h-[calc(70vh-30px)]"
          onLoad={() => {
            const loaderEle = document.getElementById("iframe-loader");
            loaderEle.style.display = "none";
          }}
        />
      </div>
    );
  };

  return (
    <>
      <Loader open={loggingUserOut} />
      <div
        className="flex items-center gap-3 cursor-pointer relative"
        onClick={() => setOpenDropdown(!openDropdown)}
      >
        <div
          className={`border ${
            color ? `border-[${color}]` : "border-theme-blue"
          } rounded-full flex items-center justify-center w-8 h-8`}
        >
          <User className="h-5 w-4" fill={color} />
        </div>
        <p className={`${color ? `text-${color}` : "text-black"}`}>
          {userDetail?.first_name}
        </p>
        <ChevronFilled
          fill={color ?? "black"}
          className={` w-[12px] h-[8px] `}
        />
        {openDropdown && (
          <div
            className={`transition-all duration-300  absolute top-[calc(100%+5px)] w-60 py-2 shadow-xl border border-theme-gray z-[1] bg-white
          ${dir === "rtl" ? "left-0" : "right-0"}
          `}
            dir={dir}
          >
            {/* <button className="w-full whitespace-nowrap px-5 py-2 cursor-pointer hover:bg-gray-100">
              {t("inboxMenuItem")}
            </button> */}
            <Link
              to="/personal-ai"
              className="w-full block text-center whitespace-nowrap px-5 py-2 cursor-pointer hover:bg-gray-100"
            >
              {t("personalAIMenuItem")}
            </Link>
            {/* <button className="w-full whitespace-nowrap px-5 py-2 cursor-pointer hover:bg-gray-100">
              {t("myAccountMenuItem")}
            </button> */}
            {/* <button className="w-full whitespace-nowrap px-5 py-2 cursor-pointer hover:bg-gray-100">
              {t('settingsMenuItem)}
            </button> */}
            {/* <button className="w-full whitespace-nowrap px-5 py-2 cursor-pointer hover:bg-gray-100">
              {t("supportMenuItem")}
            </button> */}
            <button
              className="w-full whitespace-nowrap px-5 py-2 cursor-pointer hover:bg-gray-100"
              onClick={(e) => {
                e.stopPropagation();
                showModal(
                  <RenderContent url="https://link.nexme.ai/terms" />,
                  "md"
                );
              }}
            >
              {t("termsAndPrivacy.TermsFfUse")}
            </button>
            <button
              className="w-full whitespace-nowrap px-5 py-2 cursor-pointer hover:bg-gray-100"
              onClick={(e) => {
                e.stopPropagation();
                showModal(
                  <RenderContent url="https://link.nexme.ai/privacy" />,
                  "md"
                );
              }}
            >
              {t("termsAndPrivacy.privacyPolicy")}
            </button>
            <button
              className="w-full whitespace-nowrap px-5 py-2 cursor-pointer hover:bg-gray-100"
              onClick={logout}
            >
              {t("logOutMenuItem")}
            </button>
          </div>
        )}
      </div>
    </>
  );
}
